<template>
  <div class="list-wrapper">
    <div class="content-wrapper">
      <div class="h-full">
        <div class="c_group">
          <query-form  size="small" ref='JZForm'  label-width="100px" @search="handleSearch" @reset='handleReset' class="content_block">
            <el-form-item label="销售单号">
              <el-input v-model.trim="JZForm.orderCode"  placeholder="请输入销售单号"></el-input>
            </el-form-item>
            <el-form-item label="商品名称">
              <el-input v-model.trim="JZForm.goodsName"  placeholder="请输入商品名称"></el-input>
            </el-form-item>
            <el-form-item label="规格">
              <el-input v-model.trim="JZForm.specification"  placeholder="请输入规格"></el-input>
            </el-form-item>
            <el-form-item label="型号">
              <el-input v-model.trim="JZForm.model"  placeholder="请输入型号"></el-input>
            </el-form-item>
            <el-form-item label="品牌名称">
              <el-input v-model.trim="JZForm.brandName"  placeholder="请输入品牌名称"></el-input>
            </el-form-item>
            <el-form-item label="厂家编码">
              <el-input v-model.trim="JZForm.factoryCode"  placeholder="请输入厂家编码"></el-input>
            </el-form-item>
            <el-form-item label="客户抬头">
              <el-input v-model.trim="JZForm.unit"  placeholder="请输入客户抬头"></el-input>
            </el-form-item>
            <el-form-item label="销售合同号">
              <el-input v-model.trim="JZForm.pcCode"  placeholder="请输入销售合同号"></el-input>
            </el-form-item>
            <el-form-item label="收货日期(起)" prop="operationTimeBegin" >
              <el-date-picker @change='handleSearch' type="date"  placeholder="请选择收货日期(起)" value-format="yyyy-MM-dd"  v-model.trim="JZForm.operationTimeBegin"></el-date-picker>
            </el-form-item>
            <el-form-item label="收货日期(止)" prop="operationTimeEnd" >
              <el-date-picker @change='handleSearch' type="date"  placeholder="请选择收货日期(止)" value-format="yyyy-MM-dd"  v-model.trim="JZForm.operationTimeEnd"></el-date-picker>
            </el-form-item>
          </query-form>
        </div>
        <div class="table-wrapper" :class="{ 'fullscreen': isFullScreen }">
          <xz-table
            ref="xzTable"
            :columns="columnList"
            :data="dataList"
            :toolsAttrs="toolsAttrs"
            :scroll="{ x: '100%', y: scrollHeight }"
            rowKey="id"
            @refresh="handleReset"
            @fullScreen="handleFullScreen">
            <template #buttons>
              <el-button v-if="$withPermission('gongxutong:reconciliation_settlement:return:export')" size='mini' :disabled="!total" @click.native="exportTable" type="primary" style='margin-bottom:0;'>导出</el-button>
            </template>
            <template #custom>
              <tableHeaderConfiguration businessType="returnRecord" :disabledList="disabledList" :baseLists="baseLists" @updateColumnList="updateColumnList" />
            </template>
          </xz-table>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <a-pagination
        :current="pagination.pageNum"
        :total="total"
        :show-total="total => `共 ${total || 0} 条`"
        show-size-changer
        :pageSizeOptions="['10', '20', '30', '50', '100']"
        show-quick-jumper
        :pageSize.sync="pagination.pageSize"
        @change="handleNumChange"
        @showSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import { exportRecord, getRecordLists} from '@/api/userCenter';
import * as Moment from 'dayjs';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';

const COMMON_COLUMNS = [
  {
    ellipsis: true,
    title: '客户抬头',
    width: 220,
    key: 'unit',
    dataIndex: 'unit',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '销售单号',
    width: 180,
    key: 'orderCode',
    dataIndex: 'orderCode',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '商品名称',
    width: 150,
    key: 'goodsName',
    dataIndex: 'goodsName',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '规格',
    width: 120,
    key: 'specification',
    dataIndex: 'specification',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '型号',
    width: 120,
    key: 'model',
    dataIndex: 'model',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '品牌名称',
    width: 200,
    key: 'brandName',
    dataIndex: 'brandName',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '生产厂家',
    width: 200,
    key: 'producer',
    dataIndex: 'producer',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '厂家编码',
    width: 130,
    key: 'factoryCode',
    dataIndex: 'factoryCode',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '是否医疗件',
    width: 110,
    key: 'isMedichair',
    dataIndex: 'isMedichair',
    customRender: text => {
      return text === 1 ? '是' : text === 2 ? '否' : '';
    },
  },
  {
    ellipsis: true,
    title: '计量单位',
    width: 110,
    key: 'unitOfMsment',
    dataIndex: 'unitOfMsment',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '退货数量',
    width: 110,
    key: 'num',
    dataIndex: 'num',
    customRender: text => {
      return text === '' || text === null || text === undefined ? '--' : text;
    },
  },
  {
    ellipsis: true,
    title: '退货单价',
    width: 110,
    key: 'unitPrice',
    dataIndex: 'unitPrice',
    customRender: text => {
      return text === '' || text === null || text === undefined ? '--' : text.toLocaleString('en-US', { minimumFractionDigits: 2});
    },
  },
  {
    ellipsis: true,
    title: '退货申请单号',
    width: 180,
    key: 'code',
    dataIndex: 'code',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '销售合同号',
    width: 180,
    key: 'pcCode',
    dataIndex: 'pcCode',
    customRender: text => {
      return text || '--';
    },
  },
  {
    ellipsis: true,
    title: '收货日期',
    width: 110,
    key: 'occurTime',
    dataIndex: 'occurTime',
    customRender: (text) => {
      return text ? Moment(text).format('YYYY-MM-DD') : '--';
    },
  },
];

export default {
  name: 'Product',
  components: {
    xzTable,
    tableHeaderConfiguration,
  },
  computed: {
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        // advancedSearch: true,
        custom: true,
      };
    },
  },
  created () {
    this.handleReset();
  },
  methods: {
    updateColumnList (columnList) {
      this.columnList = [
        ...columnList,
      ];
    },
    handleFullScreen () {
      this.isFullScreen = !this.isFullScreen;
    },
    handleSizeChange (_, size) {
      this.pagination.pageSize = size;
      this.getList();
    },
    handleNumChange (num) {
      this.pagination.pageNum = num;
      this.getList();
    },
    getList () {
      let currentParams = this.getCurrentParams();
      getRecordLists(currentParams).then(res => {
        let dataList = res.body.list || [];
        this.dataList = dataList.map(item=> {
          return {
            ...item,
            occurTime: Moment(item.occurTime).format('YYYY-MM-DD'),
          };
        });
        this.total = res.body.total;
      });
    },
    exportTable () {
      let currentParams = this.getCurrentParams();
      exportRecord(currentParams).then(({data}) => {
        const downloadData = {
          data: data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileTitle: `退货记录_${Date.now()}`,
        };
        this.downBinaryStreamHandle(downloadData);
      }).catch(() => {
        this.$message.error('导出失败');
      });
    },
    getCurrentParams () {
      let currentParams = {
        ...this.JZForm,
        type: 2,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      currentParams.orderBy = [{
        orderByProperty: 'createTime',
        orderByType: 'DESC',
      }];
      return currentParams;
    },
    handleSearch () {
      this.pagination.currentPage = 1;
      this.getList();
    },
    handleReset () {
      this.JZForm = {
        orderCode: '',
        goodsName: '',
        specification: '',
        model: '',
        brandName: '',
        operationTimeBegin: '',
        operationTimeEnd: '',
        pcCode: '',
        unit: '',
        factoryCode: '',
      };
      this.handleSearch();
    },
    downBinaryStreamHandle ({ data, type, fileTitle }) {
      let blob = new Blob([data], { type });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileTitle;
      document.querySelectorAll('body')[0].appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
  data () {
    return {
      disabledList: ['unit', 'orderCode', 'goodsName'],
      JZForm: {
        orderCode: '',
        goodsName: '',
        specification: '',
        model: '',
        brandName: '',
        operationTimeBegin: '',
        operationTimeEnd: '',
        pcCode: '',
        unit: '',
        factoryCode: '',
      },
      dataList: [],
      columnList: [
        ...COMMON_COLUMNS,
      ],
      baseLists: [
        ...COMMON_COLUMNS,
      ],
      scrollHeight: 600,
      isFullScreen: false,
      total: 0,
      pagination: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
};
</script>
<style scoped lang='scss'>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}
.list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 8px;

    .h-full {
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .c_group {
        position: relative;

        .content_block {
          border-bottom: 0.5px solid #DFE2E8;
          padding: 10px;
        }

        .title {
          font-size: 14px;
          font-weight: 600;
          padding-right: 2em;
        }
      }

      .table-wrapper {
        padding: 16px 12px;
        flex: 1;
        overflow: auto;

        .ant-radio-button-wrapper {
          border-width: 0;
          background-color: #f2f4f7;

          &.active-radio {
            border-color: #e2f3fe;
            background-color: #e2f3fe;
            color: #237ffa;
          }
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          width: 0;
        }
      }
    }
  }

  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #FFFFFF;
  }
}
/deep/.ant-table-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #c9ced6;
  background: #c9ced6;
}

//鼠标移入样式
/deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #c9ced6;
}

/deep/.ant-drawer-body {
  padding: 16px;
}
/deep/ .el-date-editor.el-input, /deep/ .el-date-editor.el-input__inner{
  width:100%;
}
</style>
